<template id="boton-proceso-tab-cap">
  <div>
    <div class="btn-proceso">
      <v-layout
        class="botones-colores"
        align-center
        justify-center
        fill-height
        wrap
      >
        <v-flex
          xs2
          v-for="(btn, index) in lstBtn"
          :key="index"
          @click="activateBtn(btn)"
        >
          <v-flex botones>
            <mini-statistic
              :icon="btn.icon"
              :title="btn.title"
              :sub-title="btn.subtitle"
              :color="btn.color"
              :class="btn.class"
              :value="true"
            ></mini-statistic>
          </v-flex>
        </v-flex>
      </v-layout>
    </div>
    <div class="tab-capacitacion">
      <relator-sub-tab
        v-if="tab == 'Relator'"
        :show="true"
        :tipeView="'modifica'"
        :tabDefecto="'Relator'"
      ></relator-sub-tab>
      <seleccion-sub-tab
        v-if="subPro == 'SELECCION'"
        :show="true"
        :tipeView="'modifica'"
      ></seleccion-sub-tab>
      <centro-sub-tab
        v-if="tab == 'Capacitacion' && subPro == 'CENTROS-CAP'"
        :show="true"
        :tipeView="'modifica'"
      ></centro-sub-tab>
      <administracion-sub-tab
        v-if="tab == 'Administrativo'"
        :show="true"
        :tipeView="'modifica'"
      ></administracion-sub-tab>

      <!--dsoto 16-11-2022-->
      <reportes-sub-tab
        v-if="subPro == 'REPORTES'"
        :show="true"
        :tipeView="'modifica'"
      ></reportes-sub-tab>
    </div>
  </div>
</template>

<script>
import MiniStatistic from "@/components/widgets/statistic/MiniStatistic";
import RelatorSubTab from "@/modules/capacitacion/views/relator/RelatorSubTab.vue";
import SeleccionSubTab from "@/modules/capacitacion/views/seleccion/SeleccionSubTab.vue";
import CentroSubTab from "@/modules/capacitacion/views/centros/CentroSubTab.vue";
import AdministracionSubTab from "@/modules/adminDocs/views/AdministracionSubTab.vue";
import ReportesSubTab from "@/modules/prodReport/views/ReportesSubTab.vue";

export default {
  name: "boton-proceso-tab-cap",
  props: {
    lstBtn: "",
  },
  data() {
    return {
      capacitacionBtn: false,
      tab: "Relator",
      subPro: "Sin Proceso",
    };
  },
  components: {
    MiniStatistic,
    RelatorSubTab,
    SeleccionSubTab,
    CentroSubTab,
    AdministracionSubTab,
    ReportesSubTab,
  },
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.proSelectedStored = this.$store.getters.proSelectedStored;
  },

  mounted() {},

  watch: {
    lstBtn(val) {
      //console.log("watch this.subPro:" + this.subPro + ":");
      if (this.subPro != "") {
        let btnSeleccionado = this.lstBtn.filter((d) =>
          this.subPro
            .split(" ")
            .every((v) => d.title.toLowerCase().includes(v.toLowerCase()))
        );
        //console.log("lll:" + btnSeleccionado.length + ":");
        if (btnSeleccionado.length > 0) {
          btnSeleccionado[0].class =
            "activo rombo " + this.subPro.toLowerCase();
        } else {
          //console.log("else:" + btnSeleccionado.length + ":");
          this.lstBtn.forEach((b) => {
            //console.log(":" + b.subPro + ":");
            if (b.subPro == this.subPro) {
              //console.log("activa:" + b.subPro + ":");
              b.class = "activo rombo " + this.subPro.toLowerCase();
            }
          });
        }
      }
    },
  },

  methods: {
    activateBtn(btn) {
      // console.log("st::detalle:" + JSON.stringify(btn, null, 2));

      this.tab = btn.tab;
      this.subPro = btn.subPro;
      this.$store.commit("sub_tab_state", this.tab);
      this.$store.commit("sub_pro_tab_state", this.subPro);

      this.lstBtn.forEach((b) => {
        if (b.title != btn.title) {
          //desactiva b: quita "activo" y agrega  elevation-10
          b.class = b.class.replaceAll("activo", "");
          b.class = b.class.replaceAll("elevation-10", "");
          b.class += " elevation-10";
          //console.log("desactiva:" + b.title + ":" + b.class + "::");
        } else {
          //activa b:agrega activo, quita  elevation-10
          b.class = b.class.replaceAll("elevation-10", "");
          b.class += " activo";
          //console.log("activa:" + b.title + ":" + b.class + "::");
        }
      });
    },
  },
};
</script>
